import {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";
import SelectableInput from "../../../components/SelectableInput/SelectableInput";
import useGlobalLists from "api/api-hooks/cloud/useGlobalLists";
import _ from "underscore";
import EmptyField from "../EmptyField";

const MultiSelect = (
  {
    field,
    value,
    onChange,
    placeholder,
    useMaxZIndex,
    disabled,
    mode = "rw",
    inputDisplayMode = "input",
    modifyTrigger,
    tooltipTrigger = "hover",
    table,
  },
  ref
) => {
  const selectRef = useRef();
  const [selectedRecords, setSelectedRecords] = useState(value ?? []);
  const { globalLists } = useGlobalLists();

  const handleSelect = (newVal) => {
    const newRecords = [...selectedRecords, newVal];

    setSelectedRecords(newRecords);
  };

  const handleDeselect = (oldVal) => {
    const newRecords = selectedRecords.filter(
      (record) => record.Value !== oldVal.Value
    );

    setSelectedRecords(newRecords);
  };

  const save = () => {
    onChange(
      selectedRecords?.length ? selectedRecords.map((t) => t?.Value) : []
    );
  };

  const handleClear = () => {
    setSelectedRecords([]);
    onChange([]);
  };

  useEffect(() => {
    if (!value) return setSelectedRecords([]);

    let newRecords = [];

    let values = Array.isArray(value) ? value : [value];
    if (field.SourcesList.includes("Global.Lists.")) {
      let globalList = null;
      const globalListName = field.SourcesList.split(".")[2];

      if (!globalLists) return;

      globalList = _.findWhere(globalLists, { APIName: globalListName });
      const variables = globalList?.Variables;
      for (const val of values) {
        const option = _.findWhere(variables, { Value: val });
        newRecords.push(option);
      }
    } else {
      for (const val of values) {
        const record = _.findWhere(field?.SourcesList, { Value: val });

        if (record) {
          newRecords.push(record);
        }
      }
    }

    setSelectedRecords(newRecords);
  }, [field?.SourcesList, value, globalLists]);

  useImperativeHandle(ref, () => ({
    focus: () => selectRef.current.focus(),
  }));

  return (
    <SelectableInput
      ref={selectRef}
      options={field?.SourcesList}
      labelKey="Name"
      valueKey="Value"
      colorKey="Color"
      value={selectedRecords}
      onSelect={handleSelect}
      onDeselect={handleDeselect}
      onClear={handleClear}
      inputDisplayMode={inputDisplayMode}
      field={field}
      isSensitive={field?.Sensitive ?? false}
      multiselect={true}
      maxValuesDisplayed={3}
      disabled={disabled}
      mode={mode}
      modifyTrigger={modifyTrigger}
      save={save}
      tooltipTrigger={tooltipTrigger}
      empty={<EmptyField table={table} />}
    />
  );
};

export default forwardRef(MultiSelect);
